module.exports = __webpack_public_path__ + "img/right.0336eead.gif";